export type FontFormat = 'woff2' | 'truetype' | 'opentype';

export interface BrandFontFace {
  family: string;
  weight: number;
  style: 'normal' | 'italic' | 'oblique';
  /** Guaranteed source filename (ttf/otf). */
  file: string;
  format: FontFormat;
  /** Optional woff2 filename, served first when present. */
  woff2?: string;
}

export interface BrandFontConfig {
  styleId: string;
  baseUrl: string;
  fonts: BrandFontFace[];
}

function toFontFace(baseUrl: string, { family, weight, style, file, format, woff2 }: BrandFontFace): string {
  const src = [
    ...(woff2 ? [`url('${baseUrl}/${woff2}') format('woff2')`] : []),
    `url('${baseUrl}/${file}') format('${format}')`
  ].join(',\n       ');

  return `@font-face {
  font-family: '${family}';
  font-weight: ${weight};
  font-style: ${style};
  font-display: swap;
  src: ${src};
}`;
}

export function injectBrandFonts({ styleId, baseUrl, fonts }: BrandFontConfig): void {
  if (document.getElementById(styleId)) return;

  const style = document.createElement('style');
  style.id = styleId;
  style.textContent = fonts.map(f => toFontFace(baseUrl, f)).join('\n');
  document.head.appendChild(style);
}
